import React,{useState,useEffect} from 'react'
import TopHeader from './subcomponents/TopHeader'
import BottomFooter from './subcomponents/BottomFooter';
import Grid from "@mui/material/Grid2";
import {
    Slide,
    Paper,
    Typography,
    Box,
    Stepper,
    Step,
    StepLabel,
    Button,
    Card,
    CardContent,
    CardMedia,
    CardActionArea,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    Checkbox,
    Divider,
    useTheme,
    useMediaQuery,
    CircularProgress,
    IconButton,
    Alert,
    Avatar,
    Chip
  } from '@mui/material';
  import { LocalizationProvider, DateCalendar } from '@mui/x-date-pickers';
  import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
  import { format, addDays, isEqual, isBefore } from 'date-fns';
  import ArrowBackIcon from '@mui/icons-material/ArrowBack';
  import CheckCircleIcon from '@mui/icons-material/CheckCircle';
  import AccessTimeIcon from '@mui/icons-material/AccessTime';
  import EventAvailableIcon from '@mui/icons-material/EventAvailable';
  import PersonIcon from '@mui/icons-material/Person';
  import EmailIcon from '@mui/icons-material/Email';
  import PhoneIcon from '@mui/icons-material/Phone';
function AppointmentBooking() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Select Exam Type', 'Choose Date & Doctor', 'Select Time Slot', 'Patient Information'];
    const [selectedExamType, setSelectedExamType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(addDays(new Date(), 1));
    const [availableDoctors, setAvailableDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState([]);
     const [clinicData, setClinicData] = useState({
      clinicName: "Delta Eye Clinic",
      primaryColor: "#E3F2FD",
      secondaryColor: "#00796B",
      logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
      address: "123 Main Street, Cityville, ST 12345",
      phone: "(123) 456-7890",
      fax: "(123) 456-7899",
      backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
    });
    const [patientInfo, setPatientInfo] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        dateOfBirth: '',
        isNewPatient: 'yes',
        hasInsurance: false,
        insuranceProvider: '',
        insuranceId: '',
        notes: ''
      });
      const [examTypes, setExamTypes] = useState([
        { id: 1, name: 'Regular Eye Exam', description: 'Standard vision assessment', icon: '👁️' },
        { id: 2, name: 'Adult Comprehensive Eye Exam', description: 'Detailed eye health evaluation', icon: '👓' },
        { id: 3, name: 'Kids Eye Exam', description: 'Child-friendly vision assessment', icon: '👶' },
        { id: 4, name: 'Contact Lens Fitting', description: 'Prescription and fitting service', icon: '🔍' }
      ]);
     
     useEffect(() => {
         const demoData = {
           clinicName: "Delta Eye Clinic",
           primaryColor: "#E3F2FD",
           secondaryColor: "#00796B",
           logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
           address: "123 Main Street, Cityville, ST 12345",
           phone: "(123) 456-7890",
           fax: "(123) 456-7899",
           backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
         };
         setClinicData(demoData);
         // Simulate API call
         /*fetch("/api/clinic-theme") // Replace with actual API endpoint
           .then((res) => res.json())
           .then((data) => setClinicData(data))
           .catch((err) => console.error("Error fetching clinic data:", err));*/
       }, []);
     // Simulated API calls
  useEffect(() => {
    // In a real app, these would be API calls
    if (selectedDate && activeStep === 1) {
      fetchDoctorsForDate(selectedDate);
    }
  }, [selectedDate, activeStep]);

  useEffect(() => {
    if (selectedDoctor && activeStep === 2) {
      fetchAvailableSlotsForDoctor(selectedDoctor, selectedDate);
    }
  }, [selectedDoctor, activeStep]);

  const fetchDoctorsForDate = (date) => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      const mockDoctors = [
        { 
          id: 1, 
          name: 'Dr. Sarah Johnson', 
          specialty: 'Optometrist', 
          photo: 'https://picsum.photos/200',
          experience: '12 years',
          rating: 4.9
        },
        { 
          id: 2, 
          name: 'Dr. Michael Lee', 
          specialty: 'Pediatric Optometrist', 
          photo: 'https://picsum.photos/200',
          experience: '8 years',
          rating: 4.7
        },
       
      ];
      setAvailableDoctors(mockDoctors);
      setLoading(false);
    }, 800);
  };

  const fetchAvailableSlotsForDoctor = (doctor, date) => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      const mockSlots = [
        { id: 1, time: '09:00 AM', available: true },
        { id: 2, time: '09:30 AM', available: true },
        { id: 3, time: '10:00 AM', available: true },
        { id: 4, time: '10:30 AM', available: false },
        { id: 5, time: '11:00 AM', available: true },
        { id: 6, time: '11:30 AM', available: true },
        { id: 7, time: '01:00 PM', available: true },
        { id: 8, time: '01:30 PM', available: true },
        { id: 9, time: '02:00 PM', available: false },
        { id: 10, time: '02:30 PM', available: true },
        { id: 11, time: '03:00 PM', available: true },
        { id: 12, time: '03:30 PM', available: true }
      ];
      setAvailableSlots(mockSlots);
      setLoading(false);
    }, 800);
  };

  // Event handlers
  const handleExamTypeSelect = (examType) => {
    setSelectedExamType(examType);
    handleNext();
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    setSelectedDoctor(null);
    setSelectedSlots([]);
  };

  const handleDoctorSelect = (doctor) => {
    setSelectedDoctor(doctor);
    handleNext();
  };

  const handleSlotToggle = (slot) => {
    if (!slot.available) return;
    
    if (selectedSlots.find(s => s.id === slot.id)) {
      setSelectedSlots(selectedSlots.filter(s => s.id !== slot.id));
    } else {
      if (selectedSlots.length < 2) {
        setSelectedSlots([...selectedSlots, slot]);
      }
    }
  };

  const handlePatientInfoChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPatientInfo({
      ...patientInfo,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = () => {
    setLoading(true);
    // Simulate API submission
    setTimeout(() => {
      setLoading(false);
      handleNext();
    }, 1500);
  };

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setSelectedExamType(null);
    setSelectedDate(addDays(new Date(), 1));
    setSelectedDoctor(null);
    setSelectedSlots([]);
    setPatientInfo({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      dateOfBirth: '',
      isNewPatient: 'yes',
      hasInsurance: false,
      insuranceProvider: '',
      insuranceId: '',
      notes: ''
    });
  };
// UI Components for each step
const renderExamTypeSelection = () => (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Select Type of Eye Exam</Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Choose the type of eye examination you need
      </Typography>
      
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {examTypes.map((examType) => (
          <Grid size={{xs:12,sm:6,md:3}} key={examType.id}>
            <Card 
              sx={{ 
                height: '100%',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                }
              }}
            >
              <CardActionArea 
                onClick={() => handleExamTypeSelect(examType)}
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
              >
                <Box 
                  sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    pt: 3,
                    fontSize: '3rem'
                  }}
                >
                  {examType.icon}
                </Box>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" align="center" gutterBottom>
                    {examType.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" align="center">
                    {examType.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
  const renderDateAndDoctorSelection = () => (
    <Box sx={{ mt: 4 }}>
      <Box display="flex" alignItems="center" mb={3}>
        <IconButton onClick={handleBack} sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5">
          {selectedExamType?.name} - Select Date & Doctor
        </Typography>
      </Box>
      
      <Grid container spacing={2}>
        <Grid size={{ xs:12, md:5}}>
          <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom>Select Appointment Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateCalendar 
                value={selectedDate}
                onChange={handleDateChange}
                disablePast
                sx={{ width: '100%' }}
              />
            </LocalizationProvider>
          </Paper>
        </Grid>
        
        <Grid size={{ xs:12, md:7}}>
          <Typography variant="h6" gutterBottom>Available Doctors on {format(selectedDate, 'MMMM d, yyyy')}</Typography>
          
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
              <CircularProgress />
            </Box>
          ) : availableDoctors.length > 0 ? (
            <Grid container spacing={2}>
              {availableDoctors.map((doctor) => (
                <Grid  size={{xs:12}} key={doctor.id}>
                  <Card 
                    sx={{ 
                      display: 'flex',
                      transition: 'transform 0.15s, box-shadow 0.15s',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                      }
                    }}
                  >
                    <CardActionArea onClick={() => handleDoctorSelect(doctor)}>
                      <Box sx={{ display: 'flex', p: 2 }}>
                        <CardMedia
                          component="img"
                          sx={{ width: 80, height: 80, borderRadius: '50%' }}
                          image={doctor.photo}
                          alt={doctor.name}
                        />
                        <CardContent sx={{ flex: '1 1 auto', pl: 2 }}>
                          <Typography component="div" variant="h6">
                            {doctor.name}
                          </Typography>
                          <Typography variant="subtitle1" color="text.secondary" component="div">
                            {doctor.specialty}
                          </Typography>
                          <Box sx={{ display: 'flex', mt: 1, gap: 2 }}>
                            <Chip size="small" label={`${doctor.experience} exp`} />
                           
                          </Box>
                        </CardContent>
                      </Box>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Alert severity="info">No doctors available on this date. Please select another date.</Alert>
          )}
        </Grid>
      </Grid>
    </Box>
  );

  const renderTimeSlotSelection = () => (
    <Box sx={{ mt: 4 }}>
      <Box display="flex" alignItems="center" mb={3}>
        <IconButton onClick={handleBack} sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5">
          Select Time Slot{selectedSlots.length > 0 ? `s (${selectedSlots.length}/2)` : ''}
        </Typography>
      </Box>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          {selectedDoctor?.name} - {format(selectedDate, 'MMMM d, yyyy')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please select up to 2 time slots (30 minutes each)
        </Typography>
      </Box>
      
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="200px">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid container spacing={2}>
            {availableSlots.map((slot) => (
              <Grid size={{xs:6,sm:4,md:3,lg:2}}  key={slot.id}>
                <Card 
                  sx={{ 
                    bgcolor: selectedSlots.find(s => s.id === slot.id)
                      ? theme.palette.primary.light
                      : slot.available 
                        ? 'white' 
                        : theme.palette.grey[100],
                    opacity: slot.available ? 1 : 0.6,
                    cursor: slot.available ? 'pointer' : 'not-allowed',
                    transition: 'transform 0.15s',
                    '&:hover': slot.available ? {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                    } : {},
                    position: 'relative'
                  }}
                  onClick={() => handleSlotToggle(slot)}
                >
                  <CardContent sx={{ 
                    textAlign: 'center', 
                    p: 2,
                    color: selectedSlots.find(s => s.id === slot.id) ? 'white' : 'inherit'
                  }}>
                    <AccessTimeIcon sx={{ mb: 1 }} />
                    <Typography variant="body1" fontWeight="medium">
                      {slot.time}
                    </Typography>
                    {selectedSlots.find(s => s.id === slot.id) && (
                      <CheckCircleIcon 
                        sx={{ 
                          position: 'absolute', 
                          top: 8, 
                          right: 8, 
                          color: 'white' 
                        }} 
                      />
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              variant="contained" 
              color="primary" 
              disabled={selectedSlots.length === 0}
              onClick={handleNext}
            >
              Continue
            </Button>
          </Box>
        </>
      )}
    </Box>
  );

  const renderPatientInformationForm = () => (
    <Box sx={{ mt: 4 }}>
      <Box display="flex" alignItems="center" mb={3}>
        <IconButton onClick={handleBack} sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5">
          Patient Information
        </Typography>
      </Box>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="subtitle1" color="text.secondary">
          <EventAvailableIcon sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} />
          {selectedExamType?.name} with {selectedDoctor?.name} on {format(selectedDate, 'MMMM d, yyyy')} 
          at {selectedSlots.map(slot => slot.time).join(' & ')}
        </Typography>
      </Box>
      <Box   
        display="flex"
        alignItems="center" 
        justifyContent={"center"} >

      <Grid container spacing={3} sx={{maxWidth:"sm"}}>
        <Grid size={{xs:12,sm:6}}>
          <TextField
            required
            fullWidth
            label="First Name"
            name="firstName"
            value={patientInfo.firstName}
            onChange={handlePatientInfoChange}
          />
        </Grid>
        
        <Grid size={{xs:12,sm:6}}>
          <TextField
            required
            fullWidth
            label="Last Name"
            name="lastName"
            value={patientInfo.lastName}
            onChange={handlePatientInfoChange}
          />
        </Grid>
        
        <Grid size={{xs:12,sm:6}}>
          <TextField
            required
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={patientInfo.email}
            onChange={handlePatientInfoChange}
          />
        </Grid>
        
        <Grid size={{xs:12,sm:6}}>
          <TextField
            required
            fullWidth
            label="Phone"
            name="phone"
            value={patientInfo.phone}
            onChange={handlePatientInfoChange}
          />
        </Grid>
        
        <Grid size={{xs:12,sm:6}}>
          <TextField
            required
            fullWidth
            label="Date of Birth"
            name="dateOfBirth"
            type="date"
            value={patientInfo.dateOfBirth}
            onChange={handlePatientInfoChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        
       
        
      
        
        <Grid size={{xs:12}}>
          <TextField
            fullWidth
            label="Notes or Special Requirements"
            name="notes"
            multiline
            rows={3}
            value={patientInfo.notes}
            onChange={handlePatientInfoChange}
          />
        </Grid>
      </Grid>
      </Box>
      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="contained" 
          color="primary"
          onClick={handleSubmit}
          disabled={loading || !patientInfo.firstName || !patientInfo.lastName || !patientInfo.email || !patientInfo.phone || !patientInfo.dateOfBirth}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Book Appointment"}
        </Button>
      </Box>
    </Box>
  );

  const renderThankYouMessage = () => (
    <Box 
      sx={{ 
        mt: 4, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: '50vh'
      }}
    >
      <Avatar 
        sx={{ 
          bgcolor: theme.palette.success.light, 
          width: 80, 
          height: 80,
          mb: 3
        }}
      >
        <CheckCircleIcon fontSize="large" />
      </Avatar>
      
      <Typography variant="h4" gutterBottom>
        Thank You for Booking!
      </Typography>
      
      <Typography variant="h6" color="text.secondary" paragraph>
        Your appointment request has been received.
      </Typography>
      
      <Typography variant="body1" paragraph sx={{ maxWidth: 600 }}>
        We're looking forward to seeing you! One of our staff members will contact you soon to confirm your appointment details.
      </Typography>
      
      <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="subtitle1" fontWeight="medium">
          {selectedExamType?.name} with {selectedDoctor?.name}
        </Typography>
        <Typography variant="body1">
          {format(selectedDate, 'MMMM d, yyyy')} at {selectedSlots.map(slot => slot.time).join(' & ')}
        </Typography>
      </Box>
      
      <Button 
        variant="outlined" 
        color="primary"
        onClick={handleReset}
        sx={{ mt: 4 }}
      >
        Book Another Appointment
      </Button>
    </Box>
  );


  return (
    <>
     <Box
      sx={{
       
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 3,
      }}
    >
        {clinicData && <TopHeader clinicData={clinicData} />}
        {/* Form Section */}
              <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                 <Paper
                    elevation={4}
                    sx={{
                        padding: 4,
                        maxWidth: "lg",
                        width: "100%",
                        minHeight: "80vh",
                        borderRadius: 3,
                        textAlign: "center",
                        backgroundColor: "#fff",
                        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
                        marginTop: { xs: 5, md: 14 },
                    }}
                    >
                        <Typography variant="h5"  sx={{ mb: 3, fontWeight: "bold", color: clinicData.secondaryColor }}>
                            Appointment Booking
                        </Typography>
                       
                       {/* Stepper */}
                            {activeStep < steps.length && (
                            <Stepper 
                                activeStep={activeStep} 
                                alternativeLabel={!isMobile}
                               
                                orientation='horizontal'
                                sx={{ mb: 4 }}
                            >
                                {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{!isTablet ? label : ''}</StepLabel>
                                </Step>
                                ))}
                            </Stepper>
                            )}
                            
                            {/* Content based on step */}
                            {activeStep === 0 && renderExamTypeSelection()}
                            {activeStep === 1 && renderDateAndDoctorSelection()}
                            {activeStep === 2 && renderTimeSlotSelection()}
                            {activeStep === 3 && renderPatientInformationForm()}
                            {activeStep === 4 && renderThankYouMessage()}
                                        
                    </Paper>
              </Slide>
                           
                            </Box>
                            {clinicData && <BottomFooter clinicData={clinicData} />}
    </>
  )
}

export default AppointmentBooking